import React from "react";
import { ToastContainer } from "react-toastify";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { useUser } from "./context/UserContext";
import Landing from "./pages/landing_page";
import Login from "./components/login/login";
import ForgetPassword from "./components/login/forgot-password";
import Signup from "./components/signup/signup";
import LeftNav from "./components/common/leftnav";
import Overview from "./components/overview/overview";
import Instructions from "./components/agent_settings/instructions/instructions";
import GreetingModal from "./components/agent_settings/instructions/greeting_custom/greeting";
import NewClientConfigModal from "./components/agent_settings/instructions/new_client_config/newClientConfig";
import Billing from "./components/billing/billing";
import UserManagement from "./components/user_management/userManagement";
import Notification from "./components/notification/notification";
import PaymentBilling from "./components/billing_payment/billingPayment";
import AgentSettings from "./components/agent_settings/agent_settings";
import BusinessInfo from "./components/agent_settings/business_info/business_info";
import Faqs from "./components/agent_settings/faqs/faqs";
import ContactForm from "./components/home/business_contact";
import TestNoura from "./components/test_noura/test_noura";
import TestBox from "./components/test_box/testBox";
import CustomFunction from "./components/agent_settings/instructions/custom_function/custom_function";
import GuidedSetupHomePage from "./components/guided_setup/guided_setup";
import KnowledgeBase from "./components/agent_settings/knowledge_base/knowledge_base";
import PatientForm from "./components/patient_form";
import ProtectedRoute from "./components/common/ProtectedRoute";
import ModelConfiguration from "./components/agent_settings/model_configuration/model_configuration";

function App() {
  const { user } = useUser();
  return (
    <>
      <Router>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgetPassword />} />
          <Route path="/leftnav" element={<LeftNav />} />
          <Route path="/signup" element={<Signup />} />
          <Route
            path="/guided_setup"
            element={
              <ProtectedRoute>
                {user?.isSetupComplete ? (
                  <Navigate to="/overview" replace />
                ) : (
                  <GuidedSetupHomePage />
                )}
              </ProtectedRoute>
            }
          />

          <Route
            path="/overview"
            element={
              <ProtectedRoute>
                <Overview />
              </ProtectedRoute>
            }
          />
          <Route
            path="/agent_settings/instructions"
            element={
              <ProtectedRoute>
                <Instructions />
              </ProtectedRoute>
            }
          />
          <Route
            path="/greeting"
            element={
              <ProtectedRoute>
                <GreetingModal />
              </ProtectedRoute>
            }
          />
          <Route
            path="/newClientConfig"
            element={
              <ProtectedRoute>
                <NewClientConfigModal />
              </ProtectedRoute>
            }
          />
          <Route
            path="/billing"
            element={
              <ProtectedRoute>
                <Billing />
              </ProtectedRoute>
            }
          />
          <Route
            path="/notification"
            element={
              <ProtectedRoute>
                <Notification />
              </ProtectedRoute>
            }
          />
          <Route
            path="/billing/payment"
            element={
              <ProtectedRoute>
                <PaymentBilling />
              </ProtectedRoute>
            }
          />
          <Route
            path="/agent_settings"
            element={
              <ProtectedRoute>
                <AgentSettings />
              </ProtectedRoute>
            }
          />
          <Route
            path="/agent_settings/business-info"
            element={
              <ProtectedRoute>
                <BusinessInfo />
              </ProtectedRoute>
            }
          />
          <Route
            path="/agent_settings/faqs"
            element={
              <ProtectedRoute>
                <Faqs />
              </ProtectedRoute>
            }
          />
          <Route
            path="/agent_settings/knowledge_base"
            element={
              <ProtectedRoute>
                <KnowledgeBase />
              </ProtectedRoute>
            }
          />
          <Route
            path="/agent_settings/model_configuration"
            element={
              <ProtectedRoute>
                <ModelConfiguration />
              </ProtectedRoute>
            }
          />
          <Route
            path="/business_contact"
            element={
              <ProtectedRoute>
                <ContactForm />
              </ProtectedRoute>
            }
          />
          <Route
            path="/test_noura"
            element={
              <ProtectedRoute>
                <TestNoura />
              </ProtectedRoute>
            }
          />
          <Route
            path="/test_box"
            element={
              <ProtectedRoute>
                <TestBox />
              </ProtectedRoute>
            }
          />
          <Route
            path="/custom_function"
            element={
              <ProtectedRoute>
                <CustomFunction />
              </ProtectedRoute>
            }
          />
          <Route
            path="/user_management"
            element={
              <ProtectedRoute>
                <UserManagement />
              </ProtectedRoute>
            }
          />
          <Route path="/patient-form/:token" element={<PatientForm />} />
        </Routes>
      </Router>
      {/* ToastContainer for notifications */}
      <ToastContainer
        position="top-right"
        autoClose={5000} // Close notifications after 5 seconds
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
}

export default App;
